import Vue from 'vue'

// plugins


import mdl from 'material-design-lite/material'
import VueMdl from 'vue-mdl'

// custom filter and directives
import filters from './filter'
import directives from './directive'
// mdl
Vue.use(VueMdl)

// filters and directive
_.each(
  filters,
  (filterFn, filterName) => Vue.filter(filterName, filterFn)
)

_.each(
  directives,
  (directiveFn, directiveName) => Vue.directive(directiveName, directiveFn)
)

export {filters, directives}



// WEBPACK FOOTER //
// ./assets/plugins.js